function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 132 132"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M57.421 5.913c3.002-7.884 14.156-7.884 17.158 0l8.345 21.915a36.72 36.72 0 0021.248 21.248l21.915 8.345c7.884 3.002 7.884 14.156 0 17.158l-21.915 8.345a36.719 36.719 0 00-21.248 21.248l-8.345 21.915c-3.002 7.884-14.156 7.884-17.158 0l-8.344-21.915a36.719 36.719 0 00-21.249-21.248L5.913 74.578c-7.884-3.002-7.884-14.156 0-17.158l21.915-8.344a36.72 36.72 0 0021.248-21.249z"
}));